<template>
  <layout :title="`Добавление направления/раздела`">
    <section-form :sections="sections.data"></section-form>
  </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import SectionForm from '~/Components/Section/SectionForm'

export default {
  components: {
    Layout,
    SectionForm
  },
  props: {
    sections: Object
  }
}
</script>
